export const EDITOR_PLUGINS = {
  inlineStyles: true,
  equation: true,
  colors: true,
  link: true,
  image: true,
  listTypes: true,
};

export function getDefaultInstructorIntro(course) {
  return `Welcome to ${course?.code}! This on-demand course was put together especially for ${course?.code} at ${course?.school?.short_name || course?.school?.name}. Use the video lessons and notes to understand your lecture topics better, and the practice questions to cement your knowledge. And don't hesitate to leave a question in the Q&A box under each lesson if you need additional help with anything. Happy studying!`;
}
